export default __webpack_public_path__ + "static/media/banner6.5238770c.jpg";